// initial state
const state = {
  handoutList: [],
  handoutApk: {}
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setHandout(state, payload) {
    state.handoutList = payload;
  },
  setHandoutApk(state, payload) {
    state.handoutApk = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/module/upload.js